import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onContinue: () => void,
    onCancel: () => void
}

const PendingGrowthRateChanges: React.FunctionComponent<IProps> = (props) => {
    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Pending Growth Rate Changes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                There are changes to the current growth rates.  Do you want to discard your changes and switch growth models?
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onContinue}>Continue, Discarding Changes</Button>
                <Button onClick={props.onCancel}>Cancel, Don't Discard Changes</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PendingGrowthRateChanges;